<template>
  <!-- START NOTIFICATION LIST -->
  <ul class="notification-list no-margin hidden-sm hidden-xs b-grey b-l b-r no-style p-l-30 p-r-20 breadcrumb">
    <!-- <li class="p-r-15 inline"> -->
      <!-- <div class="dropdown">
        <a href="javascript:;" id="notification-center" class="icon-set globe-fill" data-toggle="dropdown">
          <span class="bubble"></span>
        </a>
        <a href="javascript:;" id="notification-center" class="icon-set globe-fill">
          <span class="bubble"></span>
        </a>
         START Notification Dropdown -->
        <!-- <div class="dropdown-menu notification-toggle" role="menu" aria-labelledby="notification-center"> -->
          <!-- START Notification -->
          <!-- <div class="notification-panel"> -->
            <!-- START Notification Body-->
            <!-- <div class="notification-body scrollable"> -->
              <!-- START Notification Item-->
              <!-- <div class="notification-item unread clearfix"> -->
                <!-- START Notification Item-->
                <!-- <div class="heading open">
                  <a href="#" class="text-complete pull-left">
                    <i class="pg-map fs-16 m-r-10"></i>
                    <span class="bold">Carrot Design</span>
                    <span class="fs-12 m-l-10">David Nester</span>
                  </a>
                  <div class="pull-right">
                    <div class="thumbnail-wrapper d16 circular inline m-t-15 m-r-10 toggle-more-details">
                      <div><i class="fa fa-angle-left"></i>
                      </div>
                    </div>
                    <span class=" time">few sec ago</span>
                  </div>
                  <div class="more-details">
                    <div class="more-details-inner">
                      <h5 class="semi-bold fs-16">“Apple’s Motivation - Innovation <br>
                                                  distinguishes between <br>
                                                  A leader and a follower.”</h5>
                      <p class="small hint-text">
                        Commented on john Smiths wall.
                        <br> via pages framework.
                      </p>
                    </div>
                  </div>
                </div> -->
                <!-- END Notification Item-->
                <!-- START Notification Item Right Side-->
                <!-- <div class="option" data-toggle="tooltip" data-placement="left" title="mark as read">
                  <a href="#" class="mark"></a>
                </div> -->
                <!-- END Notification Item Right Side-->
              <!-- </div> -->
              <!-- START Notification Body-->
              <!-- START Notification Item-->
              <!-- <div class="notification-item  clearfix">
                <div class="heading">
                  <a href="#" class="text-danger pull-left">
                    <i class="fa fa-exclamation-triangle m-r-10"></i>
                    <span class="bold">98% Server Load</span>
                    <span class="fs-12 m-l-10">Take Action</span>
                  </a>
                  <span class="pull-right time">2 mins ago</span>
                </div> -->
                <!-- START Notification Item Right Side-->
                <!-- <div class="option">
                  <a href="#" class="mark"></a>
                </div> -->
                <!-- END Notification Item Right Side-->
              <!-- </div> -->
              <!-- END Notification Item-->
              <!-- START Notification Item-->
              <!-- <div class="notification-item  clearfix">
                <div class="heading">
                  <a href="#" class="text-warning-dark pull-left">
                    <i class="fa fa-exclamation-triangle m-r-10"></i>
                    <span class="bold">Warning Notification</span>
                    <span class="fs-12 m-l-10">Buy Now</span>
                  </a>
                  <span class="pull-right time">yesterday</span>
                </div> -->
                <!-- START Notification Item Right Side-->
                <!-- <div class="option">
                  <a href="#" class="mark"></a>
                </div> -->
                <!-- END Notification Item Right Side-->
              <!-- </div> -->
              <!-- END Notification Item-->
              <!-- START Notification Item-->
              <!-- <div class="notification-item unread clearfix">
                <div class="heading">
                  <div class="thumbnail-wrapper d24 circular b-white m-r-5 b-a b-white m-t-10 m-r-10">
                    <img width="30" height="30" data-src-retina="~assets/img/profiles/1x.jpg" data-src="~assets/img/profiles/1.jpg" alt="" src="~assets/img/profiles/1.jpg">
                  </div>
                  <a href="#" class="text-complete pull-left">
                    <span class="bold">Revox Design Labs</span>
                    <span class="fs-12 m-l-10">Owners</span>
                  </a>
                  <span class="pull-right time">11:00pm</span>
                </div> -->
                <!-- START Notification Item Right Side-->
                <!-- <div class="option" data-toggle="tooltip" data-placement="left" title="mark as read">
                  <a href="#" class="mark"></a>
                </div> -->
                <!-- END Notification Item Right Side-->
              <!-- </div> -->
              <!-- END Notification Item-->
            <!-- </div> -->
            <!-- END Notification Body-->
            <!-- START Notification Footer-->
            <!-- <div class="notification-footer text-center">
              <a href="#" class="">Read all notifications</a>
              <a data-toggle="refresh" class="portlet-refresh text-black pull-right" href="#">
                <i class="pg-refresh_new"></i>
              </a>
            </div> -->
            <!-- START Notification Footer-->
          <!-- </div> -->
          <!-- END Notification -->
        <!-- </div> -->
        <!-- END Notification Dropdown -->
      <!-- </div> -->
    <!-- </li>
    <li class="p-r-15 inline">
      <a href="#" class="icon-set clip "></a>
    </li>
    <li class="p-r-15 inline">
      <a href="#" class="icon-set grid-box"></a>
    </li> -->
    <!-- <ul class="breadcrumb"> -->
      <li>Espace Agence</li>
      <li>
        <a v-if="currentRoute === 'customer' || currentRoute === 'contract-management'" href="#" class="active">Client</a>
        <a v-else-if="currentRoute === 'customers'" href="#" class="active">Clients</a>
        <a v-else-if="currentRoute === 'prospects' || currentRoute === 'contract-management'" href="#" class="active">Prospects</a>
        <a v-else-if="currentRoute === 'crm' || currentRoute === 'lead'" href="/crm" class="active">CRM</a>
        <a v-else-if="currentRoute === 'notifications'" href="#" class="active">Notifications</a>
      </li>
      <li v-if="currentRoute === 'customer' || currentRoute === 'contract-management' ">
        {{get_customer_name}}
      </li>
      <li v-else-if="currentRoute === 'lead'">
        {{$route.params.id}}
      </li>
  </ul>
  <!-- END NOTIFICATIONS LIST -->
</template>

<style lang="scss" scoped>
.breadcrumb {
  a {
    font-size: 14px !important;
  }
}
</style>

<script>
export default {
  computed:{
    currentRoute () {
      const name = this.$route.name
      return name
    },

    get_customer_name : function() {
    //  if (this.currentRoute == "customer" ) {
      const cname = this.$store.state.customer.profile.name
      return cname
    //  }
    }
  }
}
</script>



// WEBPACK FOOTER //
// client/components/Header/NotificationList.vue